import * as types from '../mutation-types/builder-ui-modifiers'

const namespaced = true
export const namespace = 'BuilderUIModifiers'

// state
const state = {
    leftPanelModifiers: [],
    rightPanelModifiers: [],
    canvasTopBarModifiers: [],
}

// mutations
const mutations = {
    [types.ADD_LEFT_PANEL_MODIFIER](s, modifier) {
        if (!s.leftPanelModifiers.includes(modifier)) {
            s.leftPanelModifiers.push(modifier)
        }
    },
    [types.REMOVE_LEFT_PANEL_MODIFIER](s, modifier) {
        const idx = s.leftPanelModifiers.indexOf(modifier)
        if (idx >= 0) {
            s.leftPanelModifiers.splice(idx, 1)
        }
    },

    [types.ADD_RIGHT_PANEL_MODIFIER](s, modifier) {
        if (!s.rightPanelModifiers.includes(modifier)) {
            s.rightPanelModifiers.push(modifier)
        }
    },
    [types.REMOVE_RIGHT_PANEL_MODIFIER](s, modifier) {
        const idx = s.rightPanelModifiers.indexOf(modifier)
        if (idx >= 0) {
            s.rightPanelModifiers.splice(idx, 1)
        }
    },

    [types.ADD_CANVAS_TOP_BAR_MODIFIER](s, modifier) {
        if (!s.canvasTopBarModifiers.includes(modifier)) {
            s.canvasTopBarModifiers.push(modifier)
        }
    },
    [types.REMOVE_CANVAS_TOP_BAR_MODIFIER](s, modifier) {
        const idx = s.canvasTopBarModifiers.indexOf(modifier)
        if (idx >= 0) {
            s.canvasTopBarModifiers.splice(idx, 1)
        }
    },
}

// actions
const actions = {
    addLeftPanelModifier({commit}, modifier) {
        commit(types.ADD_LEFT_PANEL_MODIFIER, modifier)
    },
    removeLeftPanelModifier({commit}, modifier) {
        commit(types.REMOVE_LEFT_PANEL_MODIFIER, modifier)
    },

    addRightPanelModifier({commit}, modifier) {
        commit(types.ADD_RIGHT_PANEL_MODIFIER, modifier)
    },
    removeRightPanelModifier({commit}, modifier) {
        commit(types.REMOVE_RIGHT_PANEL_MODIFIER, modifier)
    },

    addCanvasTopBarModifier({commit}, modifier) {
        commit(types.ADD_CANVAS_TOP_BAR_MODIFIER, modifier)
    },
    removeCanvasTopBarModifier({commit}, modifier) {
        commit(types.REMOVE_CANVAS_TOP_BAR_MODIFIER, modifier)
    },
}

// getters
const getters = {
    leftPanelModifiers: s => {
        return s.leftPanelModifiers
    },

    rightPanelModifiers: s => {
        return s.rightPanelModifiers
    },

    canvasTopBarModifiers: s => {
        return s.canvasTopBarModifiers
    },
}

export default {namespaced, namespace, state, mutations, actions, getters}
